<template>
  <div>
    <div>
      <b-button-toolbar
        key-nav
        aria-label="Toolbar with button groups"
        class="demo-inline-spacing"
      >
        <b-button-group
          size="sm"
          class="cbs-inline-spacing mb-1"
        >
          <b-button
            variant="danger"
            @click="refreshTable"
          >
            <feather-icon icon="PlayIcon" />
            {{ t('Refresh') }}
          </b-button>
        </b-button-group>
        <b-button-group
          size="sm"
          class="cbs-inline-spacing mb-1"
        >
          <b-button
            v-b-tooltip.hover.top="t('Search')"
            :variant="activeTab === 'search' ? 'primary' : (search ? 'outline-success' : 'outline-primary')"
            @click="onSelectTab('search')"
          >
            <feather-icon icon="SearchIcon" />
          </b-button>
          <b-button
            v-b-tooltip.hover.top="t('Filter')"
            :variant="activeTab === 'filter' ? 'primary' : (userFilter.node.isactive ? 'outline-success' : 'outline-primary')"
            @click="onSelectTab('filter')"
          >
            <feather-icon icon="FilterIcon" />
          </b-button>
          <b-button
            v-b-tooltip.hover.top="t('Parameters')"
            :variant="activeTab === 'parameters' ? 'primary' : 'outline-primary'"
            @click="onSelectTab('parameters')"
          >
            <feather-icon icon="SlidersIcon" />
          </b-button>
          <b-button
            v-b-tooltip.hover.top="t('Rows')"
            :variant="activeTab === 'rows' ? 'primary' : 'outline-primary'"
            @click="onSelectTab('rows')"
          >
            <feather-icon icon="ListIcon" />
          </b-button>
          <b-button
            v-b-tooltip.hover.top="t('Columns')"
            :variant="activeTab === 'columns' ? 'primary' : 'outline-primary'"
            @click="onSelectTab('columns')"
          >
            <feather-icon icon="ColumnsIcon" />
          </b-button>
          <b-button
            v-b-tooltip.hover.top="t('Values')"
            :variant="activeTab === 'values' ? 'primary' : 'outline-primary'"
            @click="onSelectTab('values')"
          >
            <feather-icon icon="CrosshairIcon" />
          </b-button>
        </b-button-group>
      </b-button-toolbar>
    </div>

    <cbs-collapse :trigger="activeTab === 'search'">
      <div class="mb-1">
        <b-input-group>
          <b-input-group-prepend>
            <b-button
              variant="outline-primary"
              @click="runSearch"
            >
              <feather-icon icon="SearchIcon" /> Search
            </b-button>
          </b-input-group-prepend>
          <b-form-input
            :ref="'search_' + uuid"
            v-model="search"
            placeholder="Search"
            @keyup.enter="runSearch"
          />
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              @click="clearSearch"
            >
              <feather-icon icon="XIcon" /> Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </cbs-collapse>
    <cbs-collapse :trigger="activeTab === 'filter'">
      <div class="mb-1 p-1 rounded border border-secondary">
        <b-row>
          <b-col>
            <cbs-filter
              :filter="userFilter"
              :fields="getFields()"
            />
          </b-col>
        </b-row>
      </div>
    </cbs-collapse>
    <cbs-collapse :trigger="activeTab === 'parameters'">
      <div class="mb-1 p-1 rounded border border-secondary">
        parameters
      </div>
    </cbs-collapse>
    <cbs-collapse :trigger="activeTab === 'rows'">
      <div class="mb-1 p-1 rounded border border-secondary">
        rows
      </div>
    </cbs-collapse>
    <cbs-collapse :trigger="activeTab === 'columns'">
      <div class="mb-1 p-1 rounded border border-secondary">
        columns
      </div>
    </cbs-collapse>
    <cbs-collapse :trigger="activeTab === 'values'">
      <div class="mb-1 p-1 rounded border border-secondary">
        values
      </div>
    </cbs-collapse>

    <div
      class="border-secondary mb-1"
      style="border-radius: 0.5rem; padding: 1rem;"
    >
      table
    </div>

    <cbs-debug :context="this" />
  </div>
</template>

<script>
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import useCubus from '@/cubus/services/useCubus'
import {
  BButton, BButtonGroup, BButtonToolbar, BCol, BFormInput,
  BInputGroup, BInputGroupAppend, BInputGroupPrepend, BRow, VBTooltip,
} from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import CbsFilter from '@/cubus/components/filter/CbsFilter.vue'
import CbsCollapse from '@/cubus/components/collapsible/CbsCollapse.vue'

export default {
  name: 'CbsFormDynamic',
  components: {
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BInputGroupPrepend,
    BRow,
    CbsCollapse,
    CbsFilter,
    BCol,
    BButton,
    BButtonToolbar,
    BButtonGroup,
    CbsDebug,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    objectFull: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const { t } = useI18nUtils()
    return {
      t, // i18n
    }
  },
  data() {
    return {
      uuid: null,
      refObject: null,
      activeTab: null,
      search: null,
      userFilter: {
        node: {
          isactive: false,
          isexpanded: false,
          name: 'Root Node',
          oper: { id: 1, sid: 'and', name: 'AND' },
          nodes: [],
          conds: [],
        },
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      console.log('init')
      this.uuid = useCubus.guid()
      this.initRefObject()
    },
    async initRefObject() {
      this.refObject = await useCubus.loadObject(this, { objectid: this.objectFull.object.refobjectid })
    },
    refreshTable() {
      console.log('refreshTable')
    },
    onSelectTab(tab) {
      if (this.activeTab === tab) {
        this.activeTab = null
      } else {
        this.activeTab = tab
        if (tab === 'search') {
          this.$nextTick(() => {
            this.$refs[`search_${this.uuid}`].focus()
          })
        }
      }
    },
    getFields() {
      if (!this.refObject) return []
      return this.refObject.attributes.map(f => useCubus.attributeToField(f))
    },

    clearSearch() {
      this.search = null
    },
    runSearch() {
      this.refreshTable()
    },
  },
}
</script>

<style scoped>
</style>
